import React, { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { signOutRedirect } from "../utils/authUtils";

const Logout = () => {
  const auth = useAuth();

  useEffect(() => {
    const doLogout = async () => {
      try {
        await auth.removeUser();
        signOutRedirect();
      } catch (err) {
        console.error("[Logout] Error during logout:", err);
        // Redirect anyway to avoid getting stuck
        signOutRedirect();
      }
    };

    doLogout();
  }, [auth]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <h2>Logging out...</h2>
    </div>
  );
};

export default Logout;
